import type { MasterCategory } from "@nova-ai/shared"
import { Apple, Dumbbell, Shirt } from "lucide-react"
import type { LucideIcon } from "lucide-react"

import { StatusBadge } from "../ui/status-badge"

// Icon per master category. A run targets exactly one of these; the pill stays
// neutral (grayscale) so it never competes with the real status pills it sits
// beside — the icon + label carry the category identity, not colour.
const CATEGORY_ICONS: Record<MasterCategory, LucideIcon> = {
  clothing: Shirt,
  nutrition: Apple,
  equipment: Dumbbell,
}

export function MasterCategoryBadge({ category }: { category: MasterCategory }) {
  const Icon = CATEGORY_ICONS[category]
  return (
    <StatusBadge tone="muted" className="capitalize">
      <Icon className="size-3 shrink-0" />

      {category}
    </StatusBadge>
  )
}
